import { format } from 'date-fns';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { TransactionFilters } from '../components/transactions/hooks/useTransactionState';

export type TransactionNavigationOptions = Partial<TransactionFilters> & {
    dates?: {
        start?: string | Date | null;
        end?: string | Date | null;
    };
};

// Helper function to safely format dates
const formatDateValue = (value: string | Date | null | undefined): string | undefined => {
    if (!value) return undefined;

    if (value instanceof Date) {
        return format(value, 'yyyy-MM-dd');
    }

    return String(value);
};

export const useTransactionNavigation = () => {
    const navigate = useNavigate();

    const navigateToTransactions = useCallback(
        (options: TransactionNavigationOptions) => {
            const params = new URLSearchParams();

            if (options.flags?.length) {
                params.set('flags', options.flags.join(','));
            }
            if (options.assets?.length) {
                params.set('assets', options.assets.join(','));
            }
            if (options.search) {
                params.set('search', options.search);
            }

            const startDate = formatDateValue(options.dates?.start);
            if (startDate) {
                params.set('startDate', startDate);
            }

            const endDate = formatDateValue(options.dates?.end);
            if (endDate) {
                params.set('endDate', endDate);
            }

            if (options.types?.length) {
                params.set('types', options.types.join(','));
            }
            if (options.accounts?.length) {
                params.set('accounts', options.accounts.join(','));
            }

            navigate(`/transactions?${params.toString()}`);
        },
        [navigate]
    );

    return { navigateToTransactions };
};
